import type { SearchCriteria } from '../../model/types';

export interface ToCountriesParams {
  toCountries?: string;
}

/**
 * Множественные страны через `.` (горящие туры). В источнике `toRouterHot.js`
 * брались из коллекции `countries.pluck('id').join('.')`; в форме страна одна,
 * поэтому строка содержит один id — обратный парсинг по `.` это допускает.
 */
export function toCountries(criteria: SearchCriteria): ToCountriesParams {
  const { destination } = criteria;
  if (destination && destination.kind !== 'none') {
    return { toCountries: String(destination.country.id) };
  }
  return {};
}
